var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateFilled = function SvgCreateFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M5.778 4.75c-.568 0-1.028.46-1.028 1.028v12.444c0 .568.46 1.028 1.028 1.028h12.444c.568 0 1.028-.46 1.028-1.028v-7.11a.75.75 0 0 1 1.5 0v7.11a2.527 2.527 0 0 1-2.528 2.528H5.778a2.527 2.527 0 0 1-2.528-2.528V5.778A2.527 2.527 0 0 1 5.778 3.25h7.11a.75.75 0 0 1 0 1.5h-7.11Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M19.44 4.44c.585.585.573 1.547-.028 2.148l-8.268 8.268c-.6.6-2.433 1.483-3.018.897-.586-.586.296-2.418.897-3.019l8.268-8.267c.6-.601 1.563-.613 2.148-.028Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateFilled);
export default ForwardRef;